import React, { FC, useEffect, useRef } from 'react';
import { IPlayerProps, Player } from '@lottiefiles/react-lottie-player';
import { useInView } from 'react-intersection-observer';

import { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';
import { useBreakpoints } from 'hooks/useBreakpoints';

export type SubjectLottieProps = Omit<IPlayerProps, 'src'> & {
  entry?: FlatEntry<Subject>;
  playWhenInView?: boolean;
};

export const SubjectLottie: FC<SubjectLottieProps> = ({ entry, playWhenInView = false, ...props }) => {
  const { browser } = useBreakpoints();
  const playerRef = useRef<Player>(null);
  const { ref: rootRef, inView } = useInView();

  useEffect(
    function checkForPlayInView() {
      if (inView && playWhenInView && playerRef.current?.state.instance?.isLoaded) {
        playerRef.current.play();
      }
    },
    [inView, playWhenInView, browser.is, playerRef.current?.state.instance?.isLoaded],
  );

  if (!entry) return null;

  const { image, tabletImage, mobileImage } = entry;

  const srcDesktop = image?.file?.url;
  const srcMobile = mobileImage?.file?.url;
  const srcTablet = tabletImage?.file?.url;
  const isMobile = browser.is.mobile;
  const isTablet = browser.is.tablet;

  if (!srcDesktop) return null;

  let assetSrc = srcDesktop;

  if (isMobile && srcMobile) {
    assetSrc = srcMobile;
  } else if (isTablet && srcTablet) {
    assetSrc = srcTablet;
  }

  return (
    <figure aria-label={image.description} ref={rootRef}>
      <Player ref={playerRef} {...props} src={assetSrc} />
    </figure>
  );
};
